import { Row } from 'app/design/primitives/box';
import { Link } from 'app/design/primitives/link';
import { OpenLink } from 'app/design/icons/open-link';
import { Linking, Pressable } from 'react-native';
import { theme } from './shared';

export function PlaceWebsite({ websiteUrl }: { websiteUrl?: string }) {
  if (!websiteUrl) return null;
  return (
    <Row alignItems="center" gap="spacing.general.x1">
      <Link href={websiteUrl} numberOfLines={1} variant="bodyBase" fontWeight="700" fontSize={13}>
        {websiteUrl.replace(/^https?:\/\//, '')}
      </Link>
      <Pressable onPress={() => void Linking.openURL(websiteUrl)} hitSlop={15}>
        <OpenLink color={theme.colors['text.secondary']} width={16} height={16} />
      </Pressable>
    </Row>
  );
}
